import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL

export async function getAuthTokenFromStorage() {
    const token = localStorage.getItem("token");
    return token ? `Bearer ${token}` : "";
}
//

const axiosInstance = axios.create({
    timeout: 20000,
    baseURL: baseUrl, // Replace this with your API's base URL
});

axiosInstance.interceptors.request.use(
    async (config) => {
        const token = await getAuthTokenFromStorage();

        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// Response interceptor to handle 401 Unauthorized errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response && error.response.status === 401) {
      // remove the existing token

      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  },
);

const $axios = axiosInstance;
export { $axios };